import { Component } from '@angular/core';

@Component({
  selector: 'app-flightplanning',
  standalone: true,
  imports: [],
  templateUrl: './flightplanning.component.html',
  styleUrl: './flightplanning.component.scss'
})
export class FlightplanningComponent {

}
